import { Component, ElementRef, Inject, OnInit, ViewChild, QueryList, ViewChildren, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ProjectsCampaignFileAddComponent } from '../../dialogs/projects-campaign-file-add/projects-campaign-file-add.component';
import { MainService } from 'src/app/services/main.service';
import { ProjectsCampaignCommentsAddComponent } from '../projects-campaign-comments-add/projects-campaign-comments-add.component';
import { ProjectCampaignModel, ProjectModel, ProjectPhase, ProjectVobo } from 'src/app/models/project.model';
import { ProjectsService } from 'src/app/services/projects.service';
import Swal from 'sweetalert2';
import { BaseOverlayDispatcher } from '@angular/cdk/overlay/dispatchers/base-overlay-dispatcher';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { UsersService } from 'src/app/services/users.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ProjectDiagramationImagesComponent } from '../project-diagramation-images/project-diagramation-images.component';
import { MatButtonToggle, MatButtonToggleGroup } from '@angular/material/button-toggle';
import { map } from 'rxjs';
import { ProjectDiagramationArchivosImgComponent } from '../project-diagramation-archivos-img/project-diagramation-archivos-img.component';
import { SharedArtsDiagramViewComponent } from '../shared-arts-diagram-view/shared-arts-diagram-view.component';

if (!(Promise as any).withResolvers) {
  (Promise as any).withResolvers = () => {
    let resolver: any;
    let rechazar: any;
    const promise = new Promise((resolve, reject) => {
      resolver = resolve;
      rechazar = reject;
    });
    return { promise, resolve: resolver, reject: rechazar };
  };
}

const pdfjsLib: any = require('pdfjs-dist/build/pdf.js');

@Component({
  selector: 'app-project-diagramation-vobos',
  templateUrl: './project-diagramation-vobos.component.html',
  styleUrls: ['./project-diagramation-vobos.component.scss']
})
export class ProjectDiagramationVobosComponent implements OnInit, OnDestroy {
  @ViewChild('visorCompartido') visorCompartido?: ElementRef<HTMLDivElement>;
  @ViewChild('lienzoPdfCompartido') lienzoPdfCompartido?: ElementRef<HTMLCanvasElement>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  displayedColumns: string[] = [];
  allColumns: string[] = [];
  dspromotionFile: any = [];
  promotionFile: any = [];
  originalPromotionFile: any = [];

  @ViewChild("paginatorRes") paginatorRes!: MatPaginator;
  @ViewChild("sortRes") sortRes!: MatSort;
  displayedColumnsRes: string[] = [];
  allColumnsRes: string[] = [];
  dsResFile: any = [];
  resFile: any = [];

  curr_diagram!: any;
  phase!: ProjectPhase;
  vobo!: any;
  project: any;
  campaign: ProjectCampaignModel = new ProjectCampaignModel();
  archivos: any = [];
  artesCompartidosFase: any[] = [];
  archivosListado: any[] = [];
  urlArteCompartido = '';
  fuenteArteCompartido: SafeUrl | string = '';
  mostrandoArteCompartido = false;
  arteCompartidoEsPdf = false;
  arteCompartidoEsMultiple = false;
  anotacionCompartida: any = null;
  anotacionesCompartidasVisor: any[] = [];
  arteCompartidoVigenteAnotado: any = null;
  modoArteCompartidoMultiple = false;
  posicionesVoboCompartido: any[] = [];
  promocionesPorPosicionCompartida: any[] = [];
  columnasPromocionesCompartidas: string[] = [];
  cargandoPromocionesCompartidas = false;
  anchoArteCompartido = 0;
  altoArteCompartido = 0;
  documentoPdfCompartido: any = null;
  renderizadoPdfCompartido: any = null;
  paginaPdfCompartido = 1;
  totalPaginasPdfCompartido = 0;
  archivo_c: any = {};
  form_vb: any = [];
  form_ans: any = [];
  comentario: string = "";
  projectConf : any;
  arr_order : any = [];
  next_vobo : any = {tipo : "", users : [], arts_users: [] };
  isConsecutivo : boolean = false;
  listEvaluate : any = [];
  id_proj:number = 0;

  form!: FormGroup;
  formData : FormData = new FormData();
  selectedFiles: File[] = [];

  @ViewChildren(MatButtonToggleGroup)
  toggleGroups!: QueryList<MatButtonToggleGroup>;

  // Propiedades para edición y solicitudes
  hasChanges: boolean = false;
  editingRow: any | null = null;
  originalRowData: any = null;
  editedRows = new Map<number, { originalIndex: number, codigo: string, changes: any }>();
  listSolicitudes: any[] = [];
  lisDataSolicitudes: any[] = [];
  formedSolicitudes: any[] = [];
  file_id: number = 0;
  imagenesMultiple: any = [];
  selectedImage!: string;
  currentIndex = 0;
  art_users : any = [];
  usr_art_upload : any = [];
  user_info : any = [];
  company_name :any;
  public sanitizedSource!: SafeResourceUrl;
  constructor( 
    @Inject(MAT_DIALOG_DATA) public data : any,
    public dialogRef: MatDialogRef<ProjectDiagramationVobosComponent>,
    private projectsS: ProjectsService,
    private matDialog: MatDialog,
    private main : MainService,
    public sanitizer: DomSanitizer,
    public users : UsersService,
    private fb : FormBuilder
  ) {
    console.log("vobos data", data);
    this.curr_diagram = data.diagram;
      this.phase = data.phase;
      this.vobo = data.vobo;
      this.project = data.project;
      this.form_vb = data.form_vb;
      this.campaign = data.campaign;
      this.arr_order = data.arr_order;
      this.projectConf = data.projectConf[0];
      this.isConsecutivo = data.isConsecutivo;
      this.listEvaluate = data.listEvaluate;
      this.modoArteCompartidoMultiple = data.modoArteCompartidoMultiple === true;
      this.id_proj =  this.project.id_proy_camp;
    
      this.sanitizedSource = this.sanitizer.bypassSecurityTrustResourceUrl(''); // Inicialización
      this.form = this.fb.group({
        blob: [null]
      });
   }

  ngOnInit(): void {
     this.art_users = this.data.art_users;
     this.usr_art_upload = this.art_users.map((u:any) => u.id);
     if (this.medioPermiteArtesCompartidos()) {
       this.archivos = [];
       this.actualizarListadoArchivos();
     } else {
       this.getArchivosByPhaseAndLoadFile();
     }
     if (!this.modoArteCompartidoMultiple) {
       this.getPromotions();
       this.getRespuestas();
     }
     this.calculateNextVobo();
     this.user_info = this.users.getUser();
     this.company_name = this.user_info.current_company.nombre;
     this.cargarArtesCompartidosFase();
     if (this.modoArteCompartidoMultiple) {
       this.prepararPosicionesVoboCompartido();
       this.cargarPromocionesPosicionesCompartidas();
     }
   
  }

  private cargarArtesCompartidosFase(): void {
    if (!this.medioPermiteArtesCompartidos()) {
      this.artesCompartidosFase = [];
      this.actualizarListadoArchivos();
      return;
    }

    this.isLoadingImg = true;

    const consulta = {
      id_proyecto_campana: Number(
        this.data.datosSharedArts?.id_proy_camp
        || this.project?.id_proy_camp
      ),
      id_phase: Number(this.phase.id),
      id_medio: Number(this.curr_diagram.id_medio),
      id_pop: Number(this.curr_diagram.id_pop)
    };

    this.projectsS.getDiagramaArchivoSharedImages(consulta).subscribe({
      next: (respuesta: any) => {
        const datos = respuesta?.data?.archivos || respuesta?.data || respuesta || [];
        const imagenesHijas = respuesta?.dataF || respuesta?.data?.dataF || [];
        this.artesCompartidosFase = (Array.isArray(datos) ? datos : [])
          .filter((arte: any) => Number(arte.deleted || 0) !== 1)
          .map((arte: any) => ({
            ...arte,
            imagenes: (Array.isArray(imagenesHijas) ? imagenesHijas : []).filter((imagen: any) =>
              Number(imagen.id_diagrama_archivos_compartidos) === Number(arte.id)
            ).sort((a: any, b: any) => Number(a.id) - Number(b.id))
          }))
          .sort((a: any, b: any) => {
            return new Date(b.created_at || 0).getTime() - new Date(a.created_at || 0).getTime();
          });
        this.actualizarListadoArchivos();
        if (this.artesCompartidosFase.length) {
          this.mostrarArteCompartidoAnotado(this.artesCompartidosFase[0]);
        } else {
          this.isLoadingImg = false;
        }
      },
      error: () => {
        this.artesCompartidosFase = [];
        this.actualizarListadoArchivos();
        this.isLoadingImg = false;
      }
    });
  }

  private actualizarListadoArchivos(): void {
    const archivosDiagrama = (this.archivos || []).map((archivo: any) => ({
      ...archivo,
      esArteCompartido: false
    }));
    const artesCompartidos = this.artesCompartidosFase.map((archivo: any) => ({
      ...archivo,
      esArteCompartido: true
    }));

    this.archivosListado = [...archivosDiagrama, ...artesCompartidos].sort((a: any, b: any) =>
      new Date(b.created_at || 0).getTime() - new Date(a.created_at || 0).getTime()
    );
  }

  private async mostrarArteCompartidoAnotado(archivo: any): Promise<void> {
    const anotacion = this.obtenerAnotacionPosicion(archivo.selected_config);
    const imagenes = Array.isArray(archivo?.imagenes) ? archivo.imagenes : [];
    if (!anotacion || (!archivo.file && !imagenes.length)) {
      this.isLoadingImg = false;
      return;
    }
    this.isLoadingImg = true;
    this.arteCompartidoVigenteAnotado = archivo;
    this.arteCompartidoEsMultiple = !archivo.file && imagenes.length > 0;

    try {
      let blob: Blob | undefined;
      if (!this.arteCompartidoEsMultiple) {
        blob = await this.projectsS.getFileViewerBlob(archivo.file).toPromise();
        if (!blob) return;
      }

      this.arteCompartidoEsPdf = String(archivo.name || archivo.file).toLowerCase().split('?')[0].endsWith('.pdf')
        || String(blob?.type || '').toLowerCase().includes('pdf');
      this.anotacionCompartida = anotacion;
      if (!this.modoArteCompartidoMultiple) {
        this.anotacionesCompartidasVisor = [{
          ...anotacion,
          numero: Number(this.curr_diagram.posicion || 1),
          alias: this.curr_diagram.alias || 'Sin alias',
          estado: Number(this.obtenerVoboConfigurado(this.curr_diagram)?.status || 0)
        }];
      }
      this.mostrandoArteCompartido = true;
      this.currentIndex = 0;
      this.nivelZoom = 1;

      if (this.arteCompartidoEsPdf) {
        await new Promise(resolve => setTimeout(resolve));
        await this.mostrarPaginaPdfCompartido(blob as Blob, anotacion);
      } else if (this.arteCompartidoEsMultiple) {
        this.totalPaginasPdfCompartido = imagenes.length;
        this.paginaPdfCompartido = Math.min(
          Math.max(1, Number(anotacion.pagina || 1)),
          this.totalPaginasPdfCompartido
        );
        await this.mostrarPaginaImagenCompartida();
      } else {
        if (this.urlArteCompartido) URL.revokeObjectURL(this.urlArteCompartido);
        this.urlArteCompartido = URL.createObjectURL(blob as Blob);
        this.fuenteArteCompartido = this.sanitizer.bypassSecurityTrustUrl(this.urlArteCompartido);
      }
    } catch (error) {
      console.error('No fue posible mostrar el área anotada del arte compartido.', error);
      this.mostrandoArteCompartido = false;
    } finally {
      // En imágenes el indicador se retira hasta que el navegador termina de pintarlas.
      if (this.arteCompartidoEsPdf || !this.mostrandoArteCompartido) this.isLoadingImg = false;
      this.main.HideLoading();
    }
  }

  private obtenerAnotacionPosicion(configuracion: any): any {
    let valor = configuracion;
    if (typeof configuracion === 'string') {
      try {
        valor = JSON.parse(configuracion);
      } catch {
        return null;
      }
    }

    const anotaciones = Array.isArray(valor) ? valor : valor?.anotaciones;
    if (!Array.isArray(anotaciones)) return null;

    return anotaciones.find((anotacion: any) =>
      Number(anotacion.posicion) === Number(this.curr_diagram.posicion || 1)
    );
  }

  private prepararPosicionesVoboCompartido(): void {
    const diagramas = this.data.diagramasCompartidos || [];
    const total = Number(this.data.totalPosicionesCompartidas || 0);
    const anotaciones = this.obtenerAnotaciones(this.data.archivoCompartido?.selected_config);

    this.posicionesVoboCompartido = Array.from({ length: total }, (_valor, indice) => {
      const numero = indice + 1;
      const diagrama = diagramas.find((item: any) => Number(item.posicion || 1) === numero) || null;
      const anotacion = diagrama
        ? anotaciones.find((item: any) => Number(item.posicion) === numero)
        : null;
      const voboConfigurado = diagrama ? this.obtenerVoboConfigurado(diagrama) : null;
      const estado = Number(voboConfigurado?.status || 0);
      return {
        numero,
        diagrama,
        anotacion,
        estado,
        seleccionada: false,
        alias: diagrama?.alias || 'Sin alias'
      };
    });
    this.anotacionesCompartidasVisor = this.posicionesVoboCompartido
      .filter((posicion: any) => posicion.anotacion)
      .map((posicion: any) => ({
        ...posicion.anotacion,
        numero: posicion.numero,
        alias: posicion.alias,
        estado: posicion.estado
      }));
  }

  private obtenerAnotaciones(configuracion: any): any[] {
    let valor = configuracion;
    if (typeof configuracion === 'string') {
      try {
        valor = JSON.parse(configuracion);
      } catch {
        return [];
      }
    }
    const anotaciones = Array.isArray(valor) ? valor : valor?.anotaciones;
    return Array.isArray(anotaciones) ? anotaciones : [];
  }

  private obtenerVoboConfigurado(diagrama: any): any {
    let configuracion = diagrama?.config_vobos;
    if (!Array.isArray(configuracion)) {
      try {
        configuracion = JSON.parse(configuracion || '[]');
      } catch {
        configuracion = [];
      }
    }
    const fase = configuracion.find((item: any) => Number(item.id) === Number(this.phase.id));
    return (fase?.vobos || []).find((item: any) => Number(item.id) === Number(this.vobo.id));
  }

  posicionesSeleccionadasVobo(): any[] {
    return this.posicionesVoboCompartido.filter((posicion: any) => posicion.seleccionada);
  }

  posicionesElegiblesVobo(): any[] {
    return this.posicionesVoboCompartido.filter((posicion: any) =>
      posicion.diagrama && posicion.anotacion && Number(posicion.estado || 0) === 0
    );
  }

  todasLasPosicionesSeleccionadas(): boolean {
    const elegibles = this.posicionesElegiblesVobo();
    return elegibles.length > 0 && elegibles.every((posicion: any) => posicion.seleccionada);
  }

  seleccionParcialDePosiciones(): boolean {
    const elegibles = this.posicionesElegiblesVobo();
    const seleccionadas = elegibles.filter((posicion: any) => posicion.seleccionada).length;
    return seleccionadas > 0 && seleccionadas < elegibles.length;
  }

  seleccionarTodasLasPosiciones(seleccionar: boolean): void {
    this.posicionesElegiblesVobo().forEach((posicion: any) => {
      posicion.seleccionada = seleccionar;
    });
  }

  private cargarPromocionesPosicionesCompartidas(): void {
    this.cargandoPromocionesCompartidas = true;
    this.projectsS.getPromotionData(this.id_proj).subscribe({
      next: (respuesta: any) => {
        const promocionesCampania = Array.isArray(respuesta?.data) ? respuesta.data : [];
        const columnas = Array.isArray(respuesta?.columnas) ? respuesta.columnas : [];
        this.columnasPromocionesCompartidas = columnas.length
          ? columnas.filter((columna: any) => String(columna || '').trim())
          : (Array.from(new Set(promocionesCampania.flatMap((promocion: any) => Object.keys(promocion)))) as string[])
            .filter((columna: string) => columna.trim());

        if (this.columnasPromocionesCompartidas.length
          && !this.columnasPromocionesCompartidas.includes('CODIGO PRINCIPAL')) {
          this.columnasPromocionesCompartidas.unshift('CODIGO PRINCIPAL');
        }

        this.promocionesPorPosicionCompartida = this.posicionesVoboCompartido
          .filter((posicion: any) => posicion.anotacion)
          .map((posicion: any) => {
            const codigos = this.normalizarArreglo(posicion.diagrama?.promociones).map(String);
            return {
              numero: posicion.numero,
              alias: posicion.alias,
              pagina: 0,
              limite: 5,
              promociones: promocionesCampania.filter((promocion: any) =>
                codigos.includes(String(promocion['CODIGO PRINCIPAL'] || promocion['CÓDIGO PRINCIPAL']))
              )
            };
          });
        this.cargandoPromocionesCompartidas = false;
      },
      error: () => {
        this.promocionesPorPosicionCompartida = [];
        this.columnasPromocionesCompartidas = [];
        this.cargandoPromocionesCompartidas = false;
      }
    });
  }

  private normalizarArreglo(valor: any): any[] {
    if (Array.isArray(valor)) return valor;
    if (!valor) return [];
    try {
      const arreglo = JSON.parse(valor);
      return Array.isArray(arreglo) ? arreglo : [];
    } catch {
      return [];
    }
  }

  promocionesPaginaPosicion(posicion: any): any[] {
    const inicio = Number(posicion.pagina || 0) * Number(posicion.limite || 5);
    return (posicion.promociones || []).slice(inicio, inicio + Number(posicion.limite || 5));
  }

  cambiarPaginaPromociones(posicion: any, evento: any): void {
    posicion.pagina = Number(evento.pageIndex || 0);
    posicion.limite = Number(evento.pageSize || 5);
  }

  tituloPosicionesArte(): string {
    if (!this.modoArteCompartidoMultiple) {
      return `Posición ${Number(this.curr_diagram?.posicion || 1)}`;
    }

    const posiciones = Array.from(new Set(
      this.obtenerAnotaciones(this.data.archivoCompartido?.selected_config)
        .map((anotacion: any) => Number(anotacion.posicion))
        .filter((posicion: number) => posicion > 0)
    )).sort((a: number, b: number) => a - b);

    if (!posiciones.length) return 'Posiciones sin asignar';

    const rangos: string[] = [];
    let inicio = posiciones[0];
    let fin = posiciones[0];
    for (let indice = 1; indice < posiciones.length; indice++) {
      const posicion = posiciones[indice];
      if (posicion === fin + 1) {
        fin = posicion;
        continue;
      }
      rangos.push(inicio === fin ? `${inicio}` : `${inicio}-${fin}`);
      inicio = posicion;
      fin = posicion;
    }
    rangos.push(inicio === fin ? `${inicio}` : `${inicio}-${fin}`);

    return `${posiciones.length === 1 ? 'Posición' : 'Posiciones'} ${rangos.join(', ')}`;
  }

  tieneArteDisponibleParaResponder(): boolean {
    if (!this.tieneVoboPendienteParaResponder()) return false;

    if (this.medioPermiteArtesCompartidos()) {
      return !!this.arteCompartidoVigenteAnotado
        && Number(this.arteCompartidoVigenteAnotado.aprobado) === 1;
    }
    return Number(this.archivos[0]?.aprobado) === 1;
  }

  private tieneVoboPendienteParaResponder(): boolean {
    if (this.modoArteCompartidoMultiple) {
      return this.posicionesVoboCompartido.some((posicion: any) =>
        posicion.diagrama && posicion.anotacion && Number(posicion.estado || 0) === 0
      );
    }

    const voboConfigurado = this.obtenerVoboConfigurado(this.curr_diagram);
    return Number(voboConfigurado?.status || 0) === 0;
  }

  totalArchivosVisor(): number {
    if (this.mostrandoArteCompartido) {
      if (this.arteCompartidoEsMultiple) {
        return this.arteCompartidoVigenteAnotado?.imagenes?.length || 0;
      }
      return this.arteCompartidoVigenteAnotado ? 1 : 0;
    }
    if (this.imagenesMultiple?.length) return this.imagenesMultiple.length;
    return this.selectedImage ? 1 : 0;
  }

  private obtenerIdArteParaRespuesta(): number | null {
    if (this.medioPermiteArtesCompartidos()) return null;
    return this.archivos[0]?.id ? Number(this.archivos[0].id) : null;
  }

  medioPermiteArtesCompartidos(): boolean {
    return this.modoArteCompartidoMultiple
      || this.data?.medioUsaImagenesCompartidas === true
      || Number(this.data?.medioUsaImagenesCompartidas) === 1
      || this.curr_diagram?.imagenes_compartidas === true
      || Number(this.curr_diagram?.imagenes_compartidas) === 1;
  }

  private obtenerIdArteCompartidoParaRespuesta(): number | null {
    return this.arteCompartidoVigenteAnotado?.id
      ? Number(this.arteCompartidoVigenteAnotado.id)
      : null;
  }

  imagenCompartidaCargada(evento: Event): void {
    const imagen = evento.target as HTMLImageElement;
    this.definirTamanoArteCompartido(imagen.naturalWidth, imagen.naturalHeight);
    this.isLoadingImg = false;
  }

  estiloAnotacionCompartida(anotacion: any): any {
    return {
      left: `${Number(anotacion?.x || 0) * 100}%`,
      top: `${Number(anotacion?.y || 0) * 100}%`,
      width: `${Number(anotacion?.ancho || 0) * 100}%`,
      height: `${Number(anotacion?.alto || 0) * 100}%`,
      borderColor: anotacion?.color || '#3568ed'
    };
  }

  anotacionesPaginaPdfCompartido(): any[] {
    if (!this.arteCompartidoEsPdf && !this.arteCompartidoEsMultiple) return this.anotacionesCompartidasVisor;
    return this.anotacionesCompartidasVisor.filter((anotacion: any) =>
      Number(anotacion.pagina || 1) === this.paginaPdfCompartido
    );
  }

  async cambiarPaginaPdfCompartido(pagina: number): Promise<void> {
    if (pagina < 1 || pagina > this.totalPaginasPdfCompartido || pagina === this.paginaPdfCompartido) return;
    this.paginaPdfCompartido = pagina;
    if (this.arteCompartidoEsPdf) await this.renderizarPaginaPdfCompartido();
    else if (this.arteCompartidoEsMultiple) await this.mostrarPaginaImagenCompartida();
  }

  private async mostrarPaginaImagenCompartida(): Promise<void> {
    const imagen = this.arteCompartidoVigenteAnotado?.imagenes?.[this.paginaPdfCompartido - 1];
    if (!imagen?.file) {
      this.isLoadingImg = false;
      return;
    }

    this.isLoadingImg = true;
    this.fuenteArteCompartido = '';
    if (this.urlArteCompartido) URL.revokeObjectURL(this.urlArteCompartido);
    this.urlArteCompartido = '';
    try {
      const blob = await this.projectsS.getFileViewerBlob(imagen.file).toPromise();
      if (!blob) throw new Error('La imagen no contiene datos.');
      this.urlArteCompartido = URL.createObjectURL(blob);
      this.fuenteArteCompartido = this.sanitizer.bypassSecurityTrustUrl(this.urlArteCompartido);
    } catch {
      this.fuenteArteCompartido = imagen.file;
    }
  }

  private async mostrarPaginaPdfCompartido(blob: Blob, anotacion: any): Promise<void> {
    if (!(globalThis as any).pdfjsWorker?.WorkerMessageHandler) {
      require('pdfjs-dist/build/pdf.worker.js');
    }

    const carga = pdfjsLib.getDocument({
      data: new Uint8Array(await blob.arrayBuffer()),
      isEvalSupported: false
    });
    this.documentoPdfCompartido = await carga.promise;
    this.totalPaginasPdfCompartido = Number(this.documentoPdfCompartido.numPages || 1);
    this.paginaPdfCompartido = Math.min(
      Math.max(1, Number(anotacion.pagina || 1)),
      this.totalPaginasPdfCompartido
    );
    await this.renderizarPaginaPdfCompartido();
  }

  private async renderizarPaginaPdfCompartido(): Promise<void> {
    const lienzo = this.lienzoPdfCompartido?.nativeElement;
    if (!lienzo || !this.documentoPdfCompartido) return;
    if (this.renderizadoPdfCompartido) this.renderizadoPdfCompartido.cancel();

    try {
      const pagina = await this.documentoPdfCompartido.getPage(this.paginaPdfCompartido);
      const vista = pagina.getViewport({ scale: Math.max(1.5, window.devicePixelRatio || 1) });
      lienzo.width = Math.floor(vista.width);
      lienzo.height = Math.floor(vista.height);
      const contexto = lienzo.getContext('2d');
      if (!contexto) return;
      this.renderizadoPdfCompartido = pagina.render({ canvasContext: contexto, viewport: vista });
      await this.renderizadoPdfCompartido.promise;
      this.renderizadoPdfCompartido = null;
      this.definirTamanoArteCompartido(vista.width, vista.height);
    } catch (error: any) {
      if (error?.name !== 'RenderingCancelledException') throw error;
    }
  }

  private definirTamanoArteCompartido(anchoNatural: number, altoNatural: number): void {
    const contenedor = this.visorCompartido?.nativeElement;
    const anchoDisponible = Math.max(280, (contenedor?.clientWidth || 760) - 30);
    const altoDisponible = Math.max(280, (contenedor?.clientHeight || 480) - 30);
    const proporcion = Math.min(1, anchoDisponible / anchoNatural, altoDisponible / altoNatural);
    this.anchoArteCompartido = anchoNatural * proporcion;
    this.altoArteCompartido = altoNatural * proporcion;
  }

  nombreUsuarioArteCompartido(arte: any): string {
    return arte.nombre_usuario || arte.usuario || `Usuario ${arte.id_usuario}`;
  }

  abrirHistorialArteCompartido(): void {
    this.matDialog.open(SharedArtsDiagramViewComponent, {
      panelClass: ['dialogs-xl'],
      disableClose: true,
      data: this.data.datosSharedArts
    }).afterClosed().subscribe(resultado => {
      if (resultado?.reload) this.dialogRef.close({ reload: true });
    });
  }

  ngOnDestroy(): void {
    //mata todo lo que tiene que ver con el archivo en el navegador
    if (this.archivo_c && this.archivo_c.objectUrl) {
      URL.revokeObjectURL(this.archivo_c.objectUrl);
    }
    if (this.urlArteCompartido) URL.revokeObjectURL(this.urlArteCompartido);
    this.fuenteArteCompartido = '';
    if (this.renderizadoPdfCompartido) this.renderizadoPdfCompartido.cancel();
    if (typeof this.documentoPdfCompartido?.destroy === 'function') {
      this.documentoPdfCompartido.destroy();
    }

    if (this.dspromotionFile && this.dspromotionFile.disconnect) {
      this.dspromotionFile.disconnect();
    }

    this.promotionFile = [];
    this.originalPromotionFile = [];
    this.dspromotionFile = [];
  }
  
  checkForAlerts(){
    
  }

  hasPermissions() : boolean{

    if (this.users.isBuhoUsr()) return true;


    let voboConfigurado = this.obtenerVoboConfigurado(this.curr_diagram);
    const usuariosPermitidos = this.normalizarArreglo(
      voboConfigurado?.users ?? this.vobo?.users
    );
    const idUsuarioActual = Number(this.users.getUser()?.id);

    return usuariosPermitidos.some((idUsuario: any) => Number(idUsuario) === idUsuarioActual);
  }

  calculateNextVobo(){
    let indexActual = this.arr_order
    .map((item:any, index:number) => ({ item, index }))
    .filter(({ item } : any) => item.id_vobo === this.vobo.id)
    .map(({ index } : any) => index);
      console.log("index actual", indexActual, this.arr_order.length);
    if((indexActual[0] + 1) < this.arr_order.length){
      let next_ax = this.arr_order[indexActual[0] + 1];
      let usr_aux : any[] = [];
      let arts_users : any = [];
      switch (next_ax.tipo) {
        case "art":
          try{
            usr_aux = this.usr_art_upload
          }catch(ex){}
            this.next_vobo = {tipo : "art", users : usr_aux, arts_users: usr_aux };
          break;
        case "vobo":
      
          try{
            arts_users = this.usr_art_upload
            usr_aux = this.curr_diagram.config_vobos.filter((f:any)=> f.id == next_ax.id_fase)[0].vobos.filter((v:any)=> v.id == next_ax.id_vobo)[0].users;
          }catch(ex){}
            this.next_vobo = {tipo : "vobo", users : usr_aux, arts_users: arts_users};
          break;
        case "prov":
          try{
            arts_users = this.usr_art_upload
            usr_aux = this.curr_diagram.config_vobos.filter((f:any)=> f.id == next_ax.id_fase)[0].vobos.filter((v:any)=> v.id == next_ax.id_vobo)[0].users;
          }catch(ex){}
            this.next_vobo = {tipo : "prov", users : usr_aux, arts_users: arts_users};
          break;
        default:
          break;
      }
      
    }
  }

  setAnswer(q: any, value: boolean) {
    if(this.form_ans.some((e:any)=>e.id==q.id)) {
      this.form_ans.find((e:any)=>e.id==q.id).value = value;
    }
    else {
      this.form_ans.push({id: q.id, value});
    }
  }

  openDialogUploadCampaignFile(phase_id : number) {
    this.matDialog.open(ProjectsCampaignFileAddComponent, {
      panelClass: ['dialogs-main'],
      data: {
        phase_id : phase_id,
        id_campana_proyecto : 1,
        folder : 1,
        projectName : this.project.nombre
      }
    }).afterClosed().subscribe(
      resp => {
       
      }
    );
  }


  openDialogCommentNoAuth(phase_id : number, rol_id : number) {
    this.matDialog.open(ProjectsCampaignCommentsAddComponent, {
      panelClass: ['dialogs-sm'],
      data: {
          phase_id : phase_id,
          rol_id : rol_id,
          camp_id : 1,
          nombre : "DANGLERS VERSION 1 - FASE 1"
        }
    }).afterClosed().subscribe(
      resp => {
   
      }
    );
  }

  getArchivosByPhaseAndLoadFile() {
    this.isLoadingImg = true;
    this.main.ShowLoading();
    const data = {
        id_diagrama: this.curr_diagram.id,
        id_fase: this.phase.id
    }
    this.projectsS.getdiagramFiles(data).subscribe((x: any) => {
      if (x.data && x.data.length > 0) {
        this.archivos = x.data;
        this.actualizarListadoArchivos();
        if(this.archivos[0].file != null){
          this.archivo_c = JSON.parse(JSON.stringify(this.archivos[0]));
          this.selectedImage = this.archivo_c.file; // Aseguramos que selectedImage también se inicialice
          this.loadFileInIframe(this.archivo_c.file);
        }
        else{
          this.getMultipleImages(this.archivos[0].id);
        }
      } else {
        this.archivos = [];
        this.actualizarListadoArchivos();
        this.main.HideLoading();
        this.isLoadingImg = false;
        this.selectedImage = ''; // Limpiamos selectedImage si no hay archivos
        this.sanitizedSource = this.sanitizer.bypassSecurityTrustResourceUrl(''); // Limpiamos la fuente del iframe
      }
    },
    (err:any) => {
      console.log(err);
      this.isLoadingImg = false;
      this.main.HideLoading();
    })
  }

  isLoadingImg = false;
  loadFileInIframe(url: string) {
  
    this.isLoadingImg = true; // Muestra el spinner de carga
    this.projectsS.getFileViewerBlob(url).subscribe(
      (blob: Blob) => {
        
        if (this.archivo_c && this.archivo_c.objectUrl) {
          URL.revokeObjectURL(this.archivo_c.objectUrl);
        }

        this.archivo_c.blob = blob;
        const objectUrl = URL.createObjectURL(blob);
        this.archivo_c.objectUrl = objectUrl;
        this.updateIframeContent(); // Actualiza la fuente del iframe una vez que el blob está listo
      },
      (error: any) => {
        this.isLoadingImg = false;
        console.error('Error al cargar el archivo para previsualizar:', error);
    
        Swal.fire('Error', 'No se pudo cargar el archivo para previsualizar.', 'error');
      }
    );
  }

  updateIframeContent(): void {
    if (!this.archivo_c || !this.archivo_c.file || !this.archivo_c.objectUrl) {
      this.isLoadingImg = false;
      this.sanitizedSource = this.sanitizer.bypassSecurityTrustResourceUrl(''); 
      return;
    }
   
    this.sanitizedSource = this.sanitizer.bypassSecurityTrustResourceUrl(this.archivo_c.objectUrl);
    if (!this.isImageFile(this.selectedImage)) this.isLoadingImg = false;
    this.main.HideLoading();
  }

  config : Array<any> = [];
  editableColumns = new Set<string>();
  getPromotions() {
    this.main.ShowLoading();
    this.projectsS.getPromotionData(this.campaign.id).subscribe((x: any) => {
      
      this.file_id = x.id_file;
      this.config = x.config;
      console.log(this.file_id, this.config);

      console.log("DATA VOBO")
      console.log(x.data)


      x.data.forEach((row: any, index: number) => {
        row.status = 'normal';
        row.originalIndex = index;
        row.RESPONSABLE = row.RESPONSABLE == '' ? '-' : row.RESPONSABLE
      });

      this.promotionFile = x.data.filter((e:any)=>this.curr_diagram.promociones.includes(e["CODIGO PRINCIPAL"]));

      console.log("PROMOTION FILE")
      console.log(this.promotionFile)
      console.log("COLUMNAS")
      console.log(x.columnas)
      this.dspromotionFile = new MatTableDataSource(this.promotionFile);
      this.dspromotionFile.paginator = this.paginator;
      this.dspromotionFile.sort = this.sort;

      if(this.promotionFile != undefined){
        if(x.columnas.length > 0){
          this.displayedColumns = x.columnas;
          this.displayedColumns = this.displayedColumns.map(col => col);

          if (!this.displayedColumns.includes('CODIGO PRINCIPAL')) {
            this.displayedColumns.unshift('CODIGO PRINCIPAL');
          }
          this.allColumns = [...this.displayedColumns, 'acciones'];        
        }
        else{
          this.displayedColumns = Object.keys(this.promotionFile[0]).filter(key => key && key.trim() !== '');
          this.allColumns = [...this.displayedColumns, 'acciones'];
        } 

         this.editableColumns.clear();
            if (this.hasPermissionsDym('super_promo', null, true)) {
              this.displayedColumns.forEach(col => this.editableColumns.add(col));
            } else {
              if (this.config.length === 0) { 
                this.displayedColumns.forEach(col => this.editableColumns.add(col));
              } else if (this.config.length === 1 && this.config[0] === '_empty_') {
               
              } else {
                this.config.forEach(col => this.editableColumns.add(col));
              }
            }
            console.log("Columnas Editables:", this.editableColumns);

        this.getSolicitudes();
        this.originalPromotionFile = JSON.parse(JSON.stringify(this.promotionFile));

        this.allColumns = this.allColumns.filter(
          item => item !== "status" && item !== "originalIndex"
        );

      }    
      
      this.main.HideLoading(); 
    },
    (err:any) => {
      console.log(err);
      this.main.HideLoading();
    })
  }

  hasPermissionsDym(key : string, buho : boolean|any, client : boolean|any):  boolean {
    return this.users.hasPermissions(key, buho, client);
  }

   isColumnEditable(column: string): boolean {
    return column !== 'CODIGO PRINCIPAL' && this.editableColumns.has(column);
  }

  getSolicitudes() {
    this.main.ShowLoading();
    // Se manda `by_user = true` para obtener solo las del usuario logueado
    this.projectsS.getSolicitudes(this.id_proj, this.file_id, false).subscribe({
      next: (res: any) => {
        this.main.HideLoading();
        if (res.message === "Success") {
          this.listSolicitudes = res.solicitudes;
          this.lisDataSolicitudes = res.editados;
          console.log("solicitudes",this.listSolicitudes);
          this.formedSolicitudes = this.listSolicitudes.map((solicitud: any) => {
            const data_solicitud = this.lisDataSolicitudes.filter(
              (data: any) => data.id_solicitud === solicitud.id
            );
            const solicitudConDetalle = { ...solicitud, data_solicitud };
            return {
              ...solicitudConDetalle,
              originalIndex: this.getSolicitudOriginalIndex(solicitudConDetalle)
            };
          });

          console.log("Solicitudes de usuario formateadas:", this.formedSolicitudes);
          this.mergeSolicitudesIntoPromotions();
        }
      },
      error: (err:any) => {
        this.main.HideLoading();
        console.error("Error al obtener solicitudes:", err);
      }
    });
  }

  mergeSolicitudesIntoPromotions() {
    this.promotionFile.forEach((promo: any) => {
      // 1. Filtrar solo solicitudes de edición (tipo 1) y pendientes (status 1) para esta promoción.
      const pendingRequests = this.formedSolicitudes
        .filter(s => {
          const requestIndex = this.getSolicitudOriginalIndex(s);
          const samePromotion = requestIndex !== null
            ? requestIndex === promo.originalIndex
            : s.codigo == promo['CODIGO PRINCIPAL'];

          return samePromotion && s.tipo === 1 && s.status === 1;
        })
        .sort((a, b) => b.id - a.id); 
  
      if (pendingRequests.length > 0) {
        // 2. Consolidar los cambios de todas las solicitudes, tomando el más nuevo.
        const latestChanges = new Map<string, any>();
  
        pendingRequests.forEach(solicitud => {
          // 3. Filtrar solo cambios individuales pendientes (estatus 0).
          const pendingChanges = solicitud.data_solicitud.filter((c: any) => c.estatus === 0);
          pendingChanges.forEach((change: any) => {
            if (!latestChanges.has(change.atributo)) { // El sort previo asegura que el primero que se encuentre es el más nuevo.
              latestChanges.set(change.atributo, { ...change, id_solicitud: solicitud.id });
            }
          });
        });
  
        // 4. Asignar la data consolidada a la promoción.
        promo.solicitud = { data_solicitud: Array.from(latestChanges.values()) };
      } else {
        promo.solicitud = null;
      }
    });
  }

  private getSolicitudOriginalIndex(solicitud: any): number | null {
    const extraData = solicitud?.extra_data;
    const detailWithIndex = solicitud?.data_solicitud?.find(
      (detail: any) => detail?.fila !== null && detail?.fila !== undefined
    );
    const rawIndex = solicitud?.originalIndex
      ?? solicitud?.original_index
      ?? (typeof extraData === 'object' ? extraData?.originalIndex ?? extraData?.original_index : extraData)
      ?? detailWithIndex?.fila;

    if (rawIndex === null || rawIndex === undefined || rawIndex === '') return null;

    const originalIndex = Number(rawIndex);
    return Number.isInteger(originalIndex) && originalIndex >= 0 ? originalIndex : null;
  }

  getEvaluatedConsecutivoCount(){
      return this.listEvaluate.filter((x:any)=>x.reviewed == true).length + 1;
  }

  respuestas_copy :  Array<any> = [];
  respuestas_arr :  Array<any> = [];
  getRespuestas() {
    this.main.ShowLoading();
    this.projectsS.getProjectRespVobos(this.curr_diagram.id, this.vobo.id).subscribe((x: any) => {
      this.main.HideLoading(); 
      if(x.data.length != 0){
          this.resFile = x.data;

          const excludedCoso = ['id', 'Usuario', 'fase', 'area', 'Comentario', 'Aprobado', 'Fecha de creacion', 'imagenes_count_total', 'files_responses_array'];

          this.respuestas_copy = x.data.map((item: any) => {
            const newItem: { [key: string]: any } = {};
            for (const key in item) {
              if (!excludedCoso.includes(key)) {
                newItem[key] = item[key];
              }
            }    
            item["respuestas_arr"] = Object.keys(newItem).map(key => ({
              pregunta: key,
              respuesta: newItem[key]
            }));

            return item;
          });

          console.log(this.respuestas_copy);
    
          this.dsResFile = new MatTableDataSource(this.resFile);
          this.dsResFile.paginator = this.paginatorRes;
          this.dsResFile.sort = this.sortRes;
          this.displayedColumnsRes = Object.keys(this.resFile[0]).filter(key => key && key.trim() !== '');
          this.allColumnsRes = this.displayedColumnsRes;   
      }
    },
    (err:any) => {
      console.log(err);
      this.main.HideLoading();
    })
  }

  filterCurrent(){
    if (this.respuestas_copy.length > 0) {
      return [this.respuestas_copy[0]];
    }else{
      return [];
    }
  }

  filterOld(){
    return this.respuestas_copy.slice(1);
  }

  getFiles(file:any){

  }

  async guardarRespuestas() {
    if (!this.hasPermissions()) {
      Swal.fire(
        'Sin permisos',
        'No tienes permisos para responder este formulario de aprobación.',
        'warning'
      );
      return;
    }

    const idArte = this.obtenerIdArteParaRespuesta();
    const idArteCompartido = this.obtenerIdArteCompartidoParaRespuesta();
    if (!this.tieneArteDisponibleParaResponder() || (!idArte && !idArteCompartido)) return;

    let valid = true;
    this.form_vb.map((e:any)=> {
      if(!this.form_ans.some((v:any)=>v.id==e.id)) {
        valid = false;
      }
    });

    let aprobado = true;
    this.form_ans.map((e:any)=> {
      if(!e.value)
        aprobado = false;
    });

    if(!aprobado&&this.comentario=="") {
      valid = false;
    }
    console.log("cancel", aprobado);
    if (valid) {

      if (!aprobado) {
        const rejectedForms = this.form_ans.filter((ans: any) => !ans.value);
        const rejectedFormIds = new Set(rejectedForms.map((form: any) => form.id));
        
        const alertsToShow = (this.vobo.alerts_config || [])
          .filter((alert: any) => rejectedFormIds.has(alert.id) && alert.texto.trim() !== '')
          .map((alert: any) => {
            const form = this.form_vb.find((f: any) => f.id === alert.id);
            return `<li><b>${form?.nombre || 'Formulario desconocido'}:</b> ${alert.texto}</li>`;
          });

        if (alertsToShow.length > 0) {
          const result = await Swal.fire({
            title: 'Atención',
            html: `
              <ul style="text-align: left; padding-left: 20px;">
                ${alertsToShow.join('')}
              </ul>
              <p> ¿Desea continuar?</p>

            `,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Aceptar',
            cancelButtonText: 'Cancelar',
          });

          if (!result.isConfirmed) {
            return; // No guardar si el usuario cancela
          }
        }
      }

      
      const ins_data = { 
        id_diagrama: this.curr_diagram.id,
        id_proy_vobo: this.vobo.id, 
        id_fase: this.vobo.phase_id,
        id_arte: idArte,
        id_arte_compartido: idArteCompartido,
        respuestas: this.form_ans,
        comentario: this.comentario,
        aprobado,
        next_vobo: this.next_vobo
      };

      //Añadir los campos de texto
      this.formData.append('id_diagrama', ins_data.id_diagrama);
      this.formData.append('id_proy_vobo', ins_data.id_proy_vobo.toString());
      this.formData.append('id_fase', ins_data.id_fase.toString());
      if (ins_data.id_arte) {
        this.formData.append('id_arte', ins_data.id_arte.toString());
      }

      if (this.modoArteCompartidoMultiple) {
        await this.guardarRespuestasArteCompartido(aprobado);
        return;
      }
      if (ins_data.id_arte_compartido) {
        this.formData.append('id_arte_compartido', ins_data.id_arte_compartido.toString());
      }
      this.formData.append('respuestas', JSON.stringify(ins_data.respuestas));
      this.formData.append('comentario', ins_data.comentario);
      this.formData.append('aprobado', ins_data.aprobado.toString());
      this.formData.append('next_vobo', JSON.stringify(ins_data.next_vobo) );
      this.formData.append('folder', this.project.folder as string);   
       this.formData.append('info', JSON.stringify({vobo : this.vobo.area, phase : this.phase.name}) );   
      //Añadir los archivos (uno por uno)
      this.selectedFiles.forEach((file, index) => {
        this.formData.append(`blob_${index}`, file);
      });

      this.main.ShowLoading();
        this.projectsS.setProjectPhaseRespVobo(this.formData).subscribe(
          (result:any) => {
            this.main.HideLoading();
            if(result.message == "Success") {
              Swal.fire({
                icon: 'success',
                title: 'Guardado',
                text: 'Respuestas guardadas correctamente'          
              }).then(() => {            
                this.dialogRef.close({ reload: true });
              });
            }
            else {
              Swal.fire({
                icon: 'error',
                title: 'Error al guardar',
                text: 'Ocurrió un error al guardar el registro, por favor vuelve a intentarlo.'
              });
            }
          },
          (err:any) => {
            this.main.HideLoading();
            console.log(err);
            Swal.fire({
              icon: 'error',
              title: 'Error al guardar',
              text: 'Ocurrió un error al guardar el registro, por favor vuelve a intentarlo.'
            });
          }
        );
    }
    else {
      Swal.fire({
        icon: 'error',
        title: 'Faltan datos',
        text: 'Por favor ingrese los datos requeridos'
      });
    }
  }

  private async guardarRespuestasArteCompartido(aprobado: boolean): Promise<void> {
    const posiciones = this.posicionesSeleccionadasVobo();
    const idArteCompartido = this.obtenerIdArteCompartidoParaRespuesta();
    if (!posiciones.length) {
      Swal.fire('Sin posiciones', 'Selecciona al menos una posición pendiente para aplicar el VoBo.', 'warning');
      return;
    }
    if (!idArteCompartido) return;

    this.main.ShowLoading();
    try {
      for (const posicion of posiciones) {
        const datos = new FormData();
        datos.append('id_diagrama', posicion.diagrama.id.toString());
        datos.append('id_proy_vobo', this.vobo.id.toString());
        datos.append('id_fase', this.vobo.phase_id.toString());
        datos.append('id_arte_compartido', idArteCompartido.toString());
        datos.append('respuestas', JSON.stringify(this.form_ans));
        datos.append('comentario', this.comentario);
        datos.append('aprobado', aprobado.toString());
        datos.append('next_vobo', JSON.stringify(this.next_vobo));
        datos.append('folder', this.project.folder as string);
        datos.append('info', JSON.stringify({ vobo: this.vobo.area, phase: this.phase.name }));
        this.selectedFiles.forEach((file, indice) => datos.append(`blob_${indice}`, file));

        const resultado: any = await this.projectsS.setProjectPhaseRespVobo(datos).toPromise();
        if (resultado?.message !== 'Success') throw new Error('No fue posible guardar una de las posiciones.');
      }

      this.main.HideLoading();
      await Swal.fire('Guardado', 
        "Las respuestas se guardaron en "  + posiciones.length + " diagramación(es).",
        "success");
      this.dialogRef.close(
        { reload: true }
      );
    } catch (error) {
      this.main.HideLoading();
      console.error(error);
      Swal.fire('Error al guardar', 'No fue posible guardar el VoBo en todas las posiciones.', 'error');
    }
  }

  onFileSelected(event: Event) {
      const input = event.target as HTMLInputElement;
  
      if (input.files && input.files.length > 0) {
  
        // Filtrar solo imágenes o PDFs
        const validFiles = Array.from(input.files).filter(file =>
          file.type.startsWith('image/') || file.type === 'application/pdf'
        );
  
        if (validFiles.length !== input.files.length) {
          Swal.fire({
            icon: 'warning',
            title: 'Atención',
            text: 'Solo se permiten imágenes o archivos PDF'
          });
          input.value = '';
        }
  
        this.selectedFiles = validFiles;
        this.form.get('blob')?.setValue(this.selectedFiles);
      }
    }

  verImagenes(resp: any){
    this.matDialog.open(ProjectDiagramationImagesComponent, {
          panelClass: ['dialogs-md'],
          data: {
            ...resp,
            type: 1
          }
        }).afterClosed().subscribe(
          resp => {
          }
        );
  }

  limpiarForm(){
    this.toggleGroups.forEach(toggleGroup => {
      toggleGroup.value = null;
    });
    this.comentario = '';

    const fileInput: HTMLInputElement = document.getElementById('fileUpload') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
  }

 
public nivelZoom = 1;



public isImageFile(url: string): boolean {
  if (!url) {
    return false;
  }
  const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.svg', '.webp'];
  const lowerUrl = url.toLowerCase();
  return imageExtensions.some(ext => lowerUrl.endsWith(ext));
}

public isVideoFile(url: string): boolean {
  if (!url) { return false; }
  const videoExtensions = ['.mp4', '.webm', '.ogg', '.mov'];
  const lowerUrl = url.toLowerCase();
  return videoExtensions.some(ext => lowerUrl.endsWith(ext));
}

public isPdfFile(url: string): boolean {
  if (!url) { return false; }
  return url.toLowerCase().endsWith('.pdf');
}

public zoomIn(): void {
  if (this.mostrandoArteCompartido || this.isImageFile(this.selectedImage)) {
    this.nivelZoom = Math.min(2.5, Number((this.nivelZoom + 0.25).toFixed(2)));
  }
}

public zoomOut(): void {
  if (this.mostrandoArteCompartido || this.isImageFile(this.selectedImage)) {
    this.nivelZoom = Math.max(0.5, Number((this.nivelZoom - 0.25).toFixed(2)));
  }
}


  isRowEditing(row: any): boolean {
    return this.editingRow === row;
  }

  startEditing(row: any) {
    if (this.editingRow && this.editingRow !== row) {
      this.revertRowChanges(this.editingRow);
    }
    this.editingRow = row;
    this.originalRowData = JSON.parse(JSON.stringify(row)); // Deep copy para evitar problemas de referencia
  }

  acceptRowChanges(row: any) {
    const changes: any = {};
    const originalData = this.originalPromotionFile.find(
      (originalRow: any) => originalRow.originalIndex === row.originalIndex
    ) ?? this.originalRowData;
    const allKeys = new Set([...Object.keys(row), ...Object.keys(originalData)]);

    allKeys.forEach(key => {
      if (key === 'status' || key === 'originalIndex' || key === 'solicitud') return;

      const originalValue = originalData[key] ?? '-';
      const currentValue = row[key] ?? '-';

      if (currentValue !== originalValue) {
        changes[key] = { original: originalValue, nuevo: currentValue };
      }
    });

    if (Object.keys(changes).length > 0) {
      this.editedRows.set(row.originalIndex, {
        originalIndex: row.originalIndex,
        codigo: row['CODIGO PRINCIPAL'],
        changes
      });
      row.status = 'edited';
    } else {
      // Si no hay cambios, se revierte al estado normal
      this.editedRows.delete(row.originalIndex);
      row.status = 'normal';
    }

    this.editingRow = null;
    this.originalRowData = null;
    this.hasChanges = this.editedRows.size > 0;
    console.log("edited",this.editedRows, row);
    this.dspromotionFile._updateChangeSubscription();
  }

  revertRowChanges(row: any) {
    const rowIndex = this.dspromotionFile.data.findIndex((r: any) => r === row);
    if (rowIndex === -1) return;
    console.log(row);
    if (this.editingRow === row) {
      // Si se está cancelando la edición, restaurar desde la copia de seguridad en memoria.
      Object.assign(this.dspromotionFile.data[rowIndex], this.originalRowData);
      // Restaurar el estado que tenía antes de entrar en modo edición.
      this.dspromotionFile.data[rowIndex].status = this.originalRowData.status;
      
      this.editingRow = null;
      this.originalRowData = null;
    
    } else if (row.status === 'edited') {
      // Si se revierte una fila ya editada, restaurar desde la data original del archivo.
      const originalData = this.originalPromotionFile.find(
        (originalRow: any) => originalRow.originalIndex === row.originalIndex
      );
      if (originalData) {
        Object.assign(this.dspromotionFile.data[rowIndex], originalData);
        this.dspromotionFile.data[rowIndex].status = 'normal';
        this.editedRows.delete(row['originalIndex']);
      }  
    }

    this.hasChanges = this.editedRows.size > 0;
    console.log("Hola",this.editedRows);
    this.dspromotionFile._updateChangeSubscription();
  }

  getRowClass(row: any): string {
    if (this.editingRow === row) return 'row-editing';
    if (row.status === 'edited') return 'row-edited';
    if (row.solicitud?.data_solicitud.length > 0) return 'row-pending-request';
    return '';
  }

  getChange(solicitud: any, columnName: string): any | null {
    if (!solicitud || !solicitud.data_solicitud) {
      return null;
    }
    return solicitud.data_solicitud.find((change: any) => change.atributo === columnName && change.estatus === 0);
  }

  async sendSolicitud() {
    if (this.editedRows.size === 0) {
      Swal.fire('Sin cambios', 'No ha realizado ninguna modificación para solicitar.', 'info');
      return;
    }

    const editados = Array.from(this.editedRows.values());

    const payload = {
      id_proyecto: this.id_proj,
      id_archivo: this.file_id,
      creados: [],
      editados,
      eliminados: []
    };


    const result = await Swal.fire({
      title: '¿Enviar solicitud de cambio?',
      text: "Se enviarán las modificaciones para su aprobación.",
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sí, enviar',
      cancelButtonText: 'Cancelar'
    });

    if (result.isConfirmed) {
      this.main.ShowLoading();
      this.projectsS.createSolicitudes(payload).subscribe({
        next: (res: any) => {
          this.main.HideLoading();
          if (res.message === "Success") {
            Swal.fire('Solicitud enviada', 'Sus cambios han sido enviados para aprobación.', 'success').then(() => {
              this.editedRows.clear();
              this.hasChanges = false;
              this.getPromotions();
            });
          } else {
            Swal.fire('Error', 'Ocurrió un error al enviar la solicitud.', 'error');
          }
        },
        error: (err : any) => {
          this.main.HideLoading();
          Swal.fire('Error', 'Ocurrió un error en el servidor. Por favor, intente de nuevo.', 'error');
          console.error(err);
        }
      });
    }
  }

  getMultipleImages(id: number){
    this.main.ShowLoading();
    const data = {
        id: id
    }
    this.projectsS.getDiagramaArchivosImages(data).subscribe((x: any) => {
      if (this.mostrandoArteCompartido) {
        this.main.HideLoading();
        return;
      }
      this.imagenesMultiple = [];
      x.data.forEach((item:any) => {
        this.imagenesMultiple.push(item.file)
      })
      if (this.imagenesMultiple.length > 0) {
        this.selectedImage = this.imagenesMultiple[0]; 
        this.loadFileInIframe(this.selectedImage);
      } else {
        this.selectedImage = ''; 
        this.sanitizedSource = this.sanitizer.bypassSecurityTrustResourceUrl(''); 
        this.isLoadingImg = false;
        this.main.HideLoading();
      }
    },
    (err:any) => {
      console.log(err);
      this.isLoadingImg = false;
      this.main.HideLoading();
    })
  }

  changeImage(index: number) {
    this.currentIndex = index;
    this.nivelZoom = 1;
    const newUrl = this.imagenesMultiple[index];
    this.selectedImage = newUrl;
    this.loadFileInIframe(newUrl);
  }

   prevImage() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      const newUrl = this.imagenesMultiple[this.currentIndex];
      this.changeImage(this.currentIndex);
    }
  }

  nextImage() {
    if (this.currentIndex < this.imagenesMultiple.length - 1) {
      this.currentIndex++;
      const newUrl = this.imagenesMultiple[this.currentIndex];
      this.changeImage(this.currentIndex);
    }
  }

  openModalImages(id: number){
      this.matDialog.open(ProjectDiagramationArchivosImgComponent, {
        panelClass: ['dialogs-lg'],
        data: {
          id: id
        }
      }).afterClosed().subscribe(
        resp => {
  
        }
      );
  }
}
